export const userRegistrationInputForm = {
    title: 'Input User Information',
    selectPlaceholder: 'Please select',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter last name',
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter first name',
    jobTitle: 'Title',
    organization: 'Organization Unit',
    email: 'Email Address',
    emailPlaceholder: 'example@pwc.com',
    comment: 'Comment',
    back: 'Back',
    submit: 'Register',
    confirmTitle: 'Confirm Registration',
    confirmMessage: 'Please confirm the following information.',
    confirm: 'Register',
    cancel: 'Cancel',
    errorRequired: 'This field is required',
    errorAlphabetOnly: 'Please enter alphabet characters only',
    errorEmailInvalid: 'Invalid email format',
    errorEmailDomain: 'Please enter an email address with @pwc.com',
    errorEmailDuplicate: 'This email address is already registered',
    errorSubmitFailed: 'Registration failed. Please contact support',
    errorMaxLength100: 'Please enter within 100 characters',
    errorMaxLength200: 'Please enter within 200 characters'
}
